import React, { useEffect, useState } from "react";
import Player from "../composant/Player"; // Importer le composant Player
// Importer le composant Headervdo
import Boxevideo from "../composant/Boxevideo";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay } from '@fortawesome/free-regular-svg-icons'; // Importer l'icône de lecture


function Modal2({ onClose }) {

 // Exemple de contenu HTML à minifier
 
   const style = {
    color: 'white',
    fontFamily: 'Dreamlands, sans-serif', 
    
 };

  // État pour gérer l'animation d'ouverture du modal
  const [isOpen, setIsOpen] = useState(false);

  // État pour savoir si le contenu caché ("Découvrir") est ouvert ou fermé
  const [isContentOpen, setIsContentOpen] = useState(false);

  // État pour garder en mémoire l'index de l'épisode actuellement sélectionné
  const [currentEpisodeIndex, setCurrentEpisodeIndex] = useState(0);

  // État pour gérer l'index de l'iframe actuellement affichée dans l'épisode sélectionné
  const [currentIframeIndex, setCurrentIframeIndex] = useState(0);

  // Lance l'animation d'ouverture du modal dès que le composant est monté
  useEffect(() => {
    setIsOpen(true); // Active l'animation
  }, []);

  // Exemple de contenu HTML à minifier
 

  // Liste des épisodes, chacun ayant des URLs d'iframe, une description et un titre
  const episodes = [
    {
      id:'DEMON SL.. S4  EP8' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=5581267  ", " https://vidmoly.to/embed-8n5vjqc5fnmh.html "],
      description: " ",
      title: "",
    },



  {
      id:'DEMON SL.. S4  EP7' ,
      urls: ["  https://video.sibnet.ru/shell.php?videoid=5573417 ", " https://vidmoly.to/embed-pac8foxtbnec.html  "],
      description: " ",
      title: "",
    },


  {
      id:'DEMON SL.. S3  EP6' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=5565081   ", "  https://vidmoly.to/embed-tn3rfrkb5qhk.html  "],
      description: " ",
      title: "",
    },





  {
      id:'DEMON SL.. S4  EP5' ,
      urls: ["   https://video.sibnet.ru/shell.php?videoid=5558041 ", "  https://vidmoly.to/embed-zyrn9nliksxo.html  "],
      description: " ",
      title: "",
    },





  {
      id:'DEMON SL.. S4  EP4' ,
      urls: ["  https://video.sibnet.ru/shell.php?videoid=5552382 ", "  https://vidmoly.to/embed-op7qksmvnhe4.html  "],
      description: " ",
      title: "",
    },




  {
      id:'DEMON SL.. S4  EP3' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=5546321  ", "  https://vidmoly.to/embed-ue7566vuu8nm.html  "],
      description: " ",
      title: "",
    },



  {
      id:'DEMON SL.. S4  EP2' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=5540224   ", "  https://vidmoly.to/embed-9hsmm4pskocm.html   "],
      description: " ",
      title: "",
    },




  {
      id:'DEMON SL.. S4  EP1' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=5533798 ", " https://vidmoly.to/embed-iah3jctn5ky3.html "],
      description: " ",
      title: "",
    },




  {
      id:'DEMON SL.. S3  EP11' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=5175809 ", " https://vidmoly.to/embed-b5bpmmjit3gj.html "],
      description: " ",
      title: "",
    },


  {
      id:'DEMON SL.. S3  EP10' ,
      urls: ["   https://video.sibnet.ru/shell.php?videoid=5168522  ", "   https://vidmoly.to/embed-tj2b6gqogtci.html  "],
      description: " ",
      title: "",
    },


  {
      id:'DEMON SL.. S3  EP9' ,
      urls: ["  https://video.sibnet.ru/shell.php?videoid=5162019", "  https://vidmoly.to/embed-dqi6xqy3jc84.html  "],
      description: " ",
      title: "",
    },


  {
      id:'DEMON SL.. S3  EP8' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=5155057   ", "  https://vidmoly.to/embed-ku68b9zoxh2o.html "],
      description: " ",
      title: "",
    },



  {
      id:'DEMON SL.. S3  EP7' ,
      urls: ["  https://video.sibnet.ru/shell.php?videoid=5148330  ", "  https://vidmoly.to/embed-b7x08a8ff2s0.html  "],
      description: " ",
      title: "",
    },


  {
      id:'DEMON SL.. S3  EP6' ,
      urls: ["  https://video.sibnet.ru/shell.php?videoid=5139273  ", "  https://vidmoly.to/embed-qyx4rzrx0fab.html "],
      description: " ",
      title: "",
    },





  {
      id:'DEMON SL.. S3  EP5' ,
      urls: ["  https://video.sibnet.ru/shell.php?videoid=5129066   ", "  https://vidmoly.to/embed-jpqo2e5javpq.html   "],
      description: " ",
      title: "",
    },





  {
      id:'DEMON SL.. S3  EP4' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=5122356 ", "  https://vidmoly.to/embed-p5c3kwpcufz2.html "],
      description: " ",
      title: "",
    },




  {
      id:'DEMON SL.. S3  EP3' ,
      urls: ["  https://video.sibnet.ru/shell.php?videoid=5115500  ", "   https://vidmoly.to/embed-wmynz7lktmxb.html "],
      description: " ",
      title: "",
    },



  {
      id:'DEMON SL.. S3  EP2' ,
      urls: [" https://vidmoly.to/embed-zbxt905oojnf.html ", " https://video.sibnet.ru/shell.php?videoid=5107783  "],
      description: " ",
      title: "",
    },




  {
      id:'DEMON SL.. S3  EP1' ,
      urls: ["  https://vidmoly.to/embed-y2gacc2vdian.html  ", " https://sendvid.com/embed/jnhb11g6  "],
      description: " ",
      title: "",
    },





  {
      id:'DEMON SL.. S2  EP11' ,
      urls: [" https://vidmoly.to/embed-5pw56poteppn.html ", " https://video.sibnet.ru/shell.php?videoid=4667165 "],
      description: " ",
      title: "",
    },


  {
      id:'DEMON SL.. S2  EP10' ,
      urls: ["  https://video.sibnet.ru/shell.php?videoid=4667164  ", " https://vidmoly.to/embed-jg121fnb1xzl.html  "],
      description: " ",
      title: "",
    },


  {
      id:'DEMON SL.. S2  EP9' ,
      urls: ["  https://video.sibnet.ru/shell.php?videoid=4667157  ", "  https://sendvid.com/embed/2c16yjpx  "],
      description: " ",
      title: "",
    },


  {
      id:'DEMON SL.. S2  EP8' ,
      urls: ["https://video.sibnet.ru/shell.php?videoid=4667156 ", " https://vidmoly.to/embed-rvqm6hyhdxns.html  "],
      description: " ",
      title: "",
    },



  {
      id:'DEMON SL.. S2  EP7' ,
      urls: [" https://vidmoly.to/embed-44eyw4m7mggp.html  ", "https://video.sibnet.ru/shell.php?videoid=4667153 "],
      description: " ",
      title: "",
    },


  {
      id:'DEMON SL.. S2  EP6' ,
      urls: ["https://video.sibnet.ru/shell.php?videoid=4667151 ", " https://vidmoly.to/embed-v98a8t62b3w7.html  "],
      description: " ",
      title: "",
    },





  {
      id:'DEMON SL.. S2  EP5' ,
      urls: [" https://vidmoly.to/embed-olc3aa00fj92.html ", "  https://video.sibnet.ru/shell.php?videoid=4667149"],
      description: " ",
      title: "",
    },





  {
      id:'DEMON SL.. S2  EP4' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=4667148 ", " https://video.sibnet.ru/shell.php?videoid=4667148  "],
      description: " ",
      title: "",
    },




  {
      id:'DEMON SL.. S2  EP3' ,
      urls: ["  https://vidmoly.to/embed-m9iau4ucr7d2.html  ", "  https://video.sibnet.ru/shell.php?videoid=4667146  "],
      description: " ",
      title: "",
    },



  {
      id:'DEMON SL.. S2  EP2' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=4667145 ", " https://vidmoly.to/embed-x1wlyfrygeh7.html"],
      description: " ",
      title: "",
    },




  {
      id:'DEMON SL.. S2  EP1' ,
      urls: [" https://vidmoly.to/embed-271tfgywrrxp.html  ", " https://video.sibnet.ru/shell.php?videoid=4667143  "],
      description: " ",
      title: "",
    },





  {
      id:'FILM ' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=4825545", "  https://vidmoly.to/embed-couznlco1429.html  "],
      description: " ",
      title: "26",
    },



  {
      id:'DEMON SLAYER   26' ,
      urls: ["  https://video.sibnet.ru/shell.php?videoid=4668230 ", "  https://vidmoly.to/embed-vmwosr3lnmy0.html "],
      description: " ",
      title: "26",
    },


  {
      id:'DEMON SLAYER   25' ,
      urls: ["  https://video.sibnet.ru/shell.php?videoid=4668229 ", " https://vidmoly.to/embed-xa3lt4qgum2v.html "],
      description: " ",
      title: "25",
    },

   
  {
    id: 'DEMON SLAYER   24'  ,
    urls: [" https://video.sibnet.ru/shell.php?videoid=4668227   ", "  https://vidmoly.to/embed-i954l504hkrc.html "],
    description: "   ",
    title: "24",
  },


  {
    id: 'DEMON SLAYER   23',
    urls: [" https://video.sibnet.ru/shell.php?videoid=4668225  ", " https://vidmoly.to/embed-1ubecn1kxo6g.html "],
    description: "",
    title: " 23",
  },
 
  {
    id: 'DEMON SLAYER   22',
    urls: ["  https://video.sibnet.ru/shell.php?videoid=4668223   ", " https://vidmoly.to/embed-daaqdr68f9vl.html "],
    description: "  ",
    title: "22",
  },
 
  {
    id: 'DEMON SLAYER   21',
    urls: [" https://video.sibnet.ru/shell.php?videoid=4668216 ", " https://vidmoly.to/embed-4nk0jo7w17jv.html  "],
    description: "   ",
    title: "11",
  },




  {
      id:'DEMON SLAYER   20' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=4668212  ", "  https://video.sibnet.ru/shell.php?videoid=4668212 "],
      description: " ",
      title: "20",
    },


  {
      id:'DEMON SLAYER   19' ,
      urls: ["  https://vidmoly.to/embed-bfmnazf1u3ol.html  ", " https://video.sibnet.ru/shell.php?videoid=4668210 "],
      description: " ",
      title: "19",
    },


  {
      id:'DEMON SLAYER   18' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=4668203 ", " https://vidmoly.to/embed-2w3kkg9ss9bd.html   "],
      description: " ",
      title: "18",
    },


  {
      id:'DEMON SLAYER   17' ,
      urls: ["  https://vidmoly.to/embed-i361yiwuuvme.html  ", "https://video.sibnet.ru/shell.php?videoid=4668198 "],
      description: " ",
      title: "17",
    },

  
  {
      id:'DEMON SLAYER   16' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=4668191  ", " https://vidmoly.to/embed-5onx7lpy06r9.html   "],
      description: " ",
      title: "16",
    },


  {
      id:'DEMON SLAYER   15' ,
      urls: ["  https://vidmoly.to/embed-u4tvkf07cm3g.html ", " https://video.sibnet.ru/shell.php?videoid=4668185  "],
      description: " ",
      title: "15",
    },

   
  {
    id: 'DEMON SLAYER   14'  ,
    urls: [" https://video.sibnet.ru/shell.php?videoid=4668180    ", "  https://vidmoly.to/embed-1du8fbs6c98e.html   "],
    description: "   ",
    title: "14",
  },


  {
    id: 'DEMON SLAYER   13',
    urls: ["  https://vidmoly.to/embed-tbom7isvn6bb.html  ", "  https://video.sibnet.ru/shell.php?videoid=4668174 "],
    description: "",
    title: " 13",
  },
 
  {
    id: 'DEMON SLAYER   12',
    urls: [" https://video.sibnet.ru/shell.php?videoid=4668168  ", " https://vidmoly.to/embed-cr3tgepb05an.html "],
    description: "  ",
    title: "12",
  },
 
  {
    id: 'DEMON SLAYER   11',
    urls: [" https://vidmoly.to/embed-61wdes6batjb.html  ", "  https://video.sibnet.ru/shell.php?videoid=4668162 "],
    description: "   ",
    title: "11",
  },




  {
      id:'DEMON SLAYER   10' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=4668157 ", " https://vidmoly.to/embed-uw1fg2mmhsnj.html  "],
      description: " ",
      title: "10",
    },




  {
      id:'DEMON SLAYER   9' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=4668154 ", " https://oneupload.to/embed-r2ricmtgy5oa.html "],
      description: " ",
      title: "9",
    },


  {
      id:'DEMON SLAYER   8' ,
      urls: [" https://vidmoly.to/embed-eyqx1tzpgqv9.html ", "https://video.sibnet.ru/shell.php?videoid=4668152   "],
      description: " ",
      title: "8",
    },


  {
      id:'DEMON SLAYER   7' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=4668149  ", " https://vidmoly.to/embed-cjeop33u8gd5.html  "],
      description: " ",
      title: "7",
    },

  
  {
      id:'DEMON SLAYER   6' ,
      urls: [" https://vidmoly.to/embed-1a2saevh7dwx.html   ", " https://video.sibnet.ru/shell.php?videoid=4668146"],
      description: " ",
      title: "6",
    },


  {
      id:'DEMON SLAYER   5' ,
      urls: [" https://video.sibnet.ru/shell.php?videoid=4668143  ", " https://oneupload.to/embed-r2ricmtgy5oa.html "],
      description: " ",
      title: "5",
    },

   
  {
    id: 'DEMON SLAYER   4'  ,
    urls: [" https://video.sibnet.ru/shell.php?videoid=4668139 ", " https://oneupload.to/embed-t98k1p7sq922.html"],
    description: "   ",
    title: "4",
  },


  {
    id: 'DEMON SLAYER   3',
    urls: ["https://vidmoly.to/embed-59vss3vcxzbv.html  ", "   https://video.sibnet.ru/shell.php?videoid=4668135  "],
    description: "",
    title: "1121",
  },
 
  {
    id: 'DEMON SLAYER   2',
    urls: [" https://oneupload.to/embed-4nci6qtbbi1n.html ", "  https://video.sibnet.ru/shell.php?videoid=4668131"],
    description: "  ",
    title: "2",
  },
 
  {
    id: 'DEMON SLAYER   1',
    urls: ["https://video.sibnet.ru/shell.php?videoid=4668120 ", " https://vidmoly.to/embed-jhjse50c3rpx.html "],
    description: "   ",
    title: "1119",
  },
 

   
  ];

  // Sélectionne l'épisode actuellement en cours d'affichage basé sur l'index actuel
  const currentEpisode = episodes[currentEpisodeIndex];

  // URL de l'iframe actuelle à afficher pour l'épisode sélectionné
  const currentIframeUrl = currentEpisode.urls[currentIframeIndex];

  // Fonction pour basculer l'affichage de la section "Découvrir"
  const toggleContent = () => {
    setIsContentOpen((prevState) => !prevState); // Inverse l'état pour ouvrir ou fermer
  };

  // Fonction pour changer d'épisode en cliquant dans la section "Découvrir"
  const selectEpisode = (index) => {
    setCurrentEpisodeIndex(index); // Met à jour l'index de l'épisode actuel
    setCurrentIframeIndex(0); // Réinitialise l'index de l'iframe pour chaque nouvel épisode
    setIsContentOpen(false); // Ferme la section "Découvrir" après sélection d'un épisode
  };

  // Fonction pour afficher la première iframe en cliquant sur le premier bouton Player
  const handleFirstPlayerClick = () => {
    setCurrentIframeIndex(0); // Affiche toujours la première iframe
  };

  // Fonction pour basculer entre la deuxième et la troisième iframe avec le deuxième bouton Player
  const handleSecondPlayerClick = () => {
    setCurrentIframeIndex((prevIndex) => {
      const newIndex = prevIndex === 1 ? 2 : 1;
      console.log("Updated iframe index:", newIndex); // Affiche le nouvel index
      return newIndex;
    });
  };

  // Fonction pour naviguer à l'épisode précédent
  const goToPreviousEpisode = () => {
    setCurrentEpisodeIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    setCurrentIframeIndex(0); // Réinitialise l'iframe à 0 lorsque vous changez d'épisode
  };

  // Fonction pour naviguer à l'épisode suivant
  const goToNextEpisode = () => {
    setCurrentEpisodeIndex((prevIndex) => Math.min(prevIndex + 1, episodes.length - 1));
    setCurrentIframeIndex(0); // Réinitialise l'iframe à 0 lorsque vous changez d'épisode
  };

  
  return (
    <div   className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm overflow-y-scroll  overflow-x-scroll  max-sm:overflow-x-hidden  max-xs:overflow-x-hidden  ">
     
      {/* Conteneur principal avec animation d'ouverture et de fermeture */}
      <div
        className={`${
          isOpen ? "opacity-100 scale-100" : "opacity-0 scale-90"
        } transition-all duration-300 relative transform bg-black    p-6 rounded-md shadow-lg w-[40%] h-[125%] top-[30%] left-[25%]
         max-sm:left-[-0%]  max-sm:w-[90%]  max-sm:h-[160%]    max-sm:top-[35%]       max-xs:h-[160%]    max-xs:top-[30%] 
 max-md:left-[8%]  max-md:w-[80%] 
max-lg:left-[10%]  max-lg:w-[70%]   max-lg:h-[250%]        max-lg:top-[90%]     
 max-xl:left-[22%]  max-xl:w-[50%]     flex flex-col  


        
        `}
      >
        <main className=" relative top-40 h-screen space-y-24  ">
          <Boxevideo>
           {/* Affiche le composant Headervdo */}
             <div className="w-[98%]  relative  h-[50%]  top-[-10%]   left-2
              max-sm:left-[206%] max-sm:w-[120%]   max-sm:top-[5%]
             
             ">
            {/* iFrame pour l'URL de la vidéo de l'épisode actuel */}
            <iframe
      
              src={currentIframeUrl} // Utilise l'URL de l'iframe actuelle
              width="100%"
              height="100%"
              frameBorder="0"
              allowFullScreen
              title={`Épisode ${currentEpisode.id} : Détails Complet`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              onload="this.onload=null;"
              
            ></iframe>

                </div>


            {/* Bouton pour fermer le modal */}
            <button
              className="div6 absolute top-[60%] left-[10%] text-white hover:text-purple-400 animate-bounce text-5xl font-bold
              
                 max-sm:top-[70%]   max-sm:left-[210%]   max-xs:top-[82%]
                   max-xl:top-[70%]   max-lg:top-[89%]
              "
              onClick={onClose} // Fonction onClose passée en prop pour fermer le modal
            >
              &times;
            </button>

            {/* Boutons Player pour afficher les différentes iframes */}
            <div className="div2 flex relative top-[-10%] space-x-40  justify-center mt-4  
              
            
                max-sm:top-[5%]   max-sm:left-[220%]   max-sm:space-x-20      max-lg:top-[-10%] 
            
            
            ">
              <Player onClick={handleFirstPlayerClick} >1</Player>
              <Player onClick={handleSecondPlayerClick}>2</Player>
            </div>

            {/* Description de l'épisode actuel */}
            <p className="text-center relative top-[-10%] text-sm text-white w-[50%] mx-auto mt-4
                  max-sm:left-[220%] max-sm:top-[8%]    max-sm:w-[90%]   max-sm:text-xs
            
            
            ">
              {currentEpisode.description}
            </p>

            {/* Titre de l'épisode actuel */}
            <h1 className="div3 text-white text-center text-2xl relative top-[-6%]  
             max-sm:left-[218%]     max-sm:top-[12%]      max-xs:top-[9%]  max-xs:text-xl
             max-xl:top-[-10%]         max-lg:top-[-5%]
            "   style={style}  >
              {currentEpisode.id}
            </h1>
          </Boxevideo>

          {/* Boutons de navigation */}
          <div className=" div4 flex justify-between relative top-[-45%] mx-auto mt-8 w-1/2    
          max-sm:space-x-26     max-sm:left-[-10%]       max-sm:top-[-40%]
            max-xs:top-[-36%]        max-lg:top-[-46%] 
          
          ">
            <button
              onClick={goToPreviousEpisode}
              disabled={currentEpisodeIndex === 0}
              className=" bg-fuchsia-600 hover:opacity-80 rounded font-semibold text-white p-3 transition-all duration-200 disabled:opacity-50
              
              
              
              "
            >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 md:h-5 md:w-5 md:mr-3" viewBox="0 0 20 20" fill="currentColor">
		<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.707-10.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L9.414 11H13a1 1 0 100-2H9.414l1.293-1.293z" clip-rule="evenodd"></path>
	</svg>
            </button>





            <button
              onClick={goToNextEpisode}
              disabled={currentEpisodeIndex >= episodes.length - 1}
              className="bg-fuchsia-600 hover:opacity-80 rounded font-semibold text-white p-3 transition-all duration-200 disabled:opacity-50  relative  max-sm:left-[35%]"
              
            >
<svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 md:h-5 md:w-5 md:ml-3" viewBox="0 0 20 20" fill="currentColor">
		<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z" clip-rule="evenodd"></path>
	</svg>
                
                
            
            </button>
          </div>
         
        {/* Section "Découvrir" pour sélectionner un épisode */}
        <div className="div5 relative top-[-50%] left-0 right-0 p-4 
             max-sm:top-[-45%]         max-md:top-[-10%]    max-xs:top-[-40%]    max-lg:top-[-45%] 
              max-xl:top-[-18%]  
        ">
           <button
            onClick={toggleContent} // Appel à la fonction toggleContent
            className="w-full bg-fuchsia-600 text-white p-4 rounded-lg shadow-md text-left flex items-center justify-between"
            style={style}
          >
            <span className="text-lg"> VOIR PLUS...</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className={`transition-transform duration-300 transform ${
                isContentOpen ? "rotate-180" : "rotate-0"
              }`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </button>

          {/* Liste des épisodes à découvrir */}
          {isContentOpen && (
            <div className="mt-4 space-y-4 h-64 overflow-y-scroll">
              {episodes.map((episode, index) => (
                <div
                  key={episode.id}
                  className="p-4 rounded-lg shadow-md text-white cursor-pointer bg-gray-700 hover:bg-gray-300"
                  onClick={() => selectEpisode(index)} // Appel à selectEpisode pour afficher l'épisode
                >
                  <h3 className="text-md text-white flex items-center font-semibold">
                    <FontAwesomeIcon icon={faCirclePlay} />
                    <span className="ml-2"    >{episode.id}</span>
                  </h3>
                  <p>{episode.description}</p>
                </div>
              ))}
            </div>
            
          )}
        </div>
        </main>

      </div>
      
    </div>
    
  );
  
}

export default Modal2;